// Progress step definitions
// Step 1: Select Vehicle
// Step 2: Select Service
// Step 3: Select Time Slot
// Step 4: Confirmation
// Step 5: Success

export const STEP_INDICES = {
  SELECT_VEHICLE: "select-vehicle",
  SELECT_SERVICE: "service-select",
  SELECT_TIME_SLOT: "slot-select",
  CONFIRMATION: "confirmation",
  SUCCESS: "success",
} as const;

export const STEPS = {
  SELECT_VEHICLE: { step: 1, title: "Vehicle" },
  SELECT_SERVICE: { step: 2, title: "Service" },
  SELECT_TIME_SLOT: { step: 3, title: "Time" },
  CONFIRMATION: { step: 4, title: "Confirm" },
  SUCCESS: { step: 5, title: "Complete" },
} as const;
